import * as React from 'react';
import { Label } from '../label';
import { FormControl, FormItem, FormMessage } from '../form';
import { SelectProps } from '@radix-ui/react-select';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';

export interface SelectContentProps {
  name: string;
  value: string;
}

interface SelectGsProps extends SelectProps {
  label?: string;
  content: SelectContentProps[];
  isLoading?: boolean;
  disabled?: boolean;
}

const SelectGs = React.forwardRef<HTMLBaseElement, SelectGsProps>(
  ({ label, onValueChange, value, content, disabled, isLoading = false }, ref) => {
    return (
      <FormItem {...ref}>
        <div className="grid w-full items-center gap-1.5">
          {label && (
            <Label className="font-GilroySemibold text-sm text-slate-800">
              {label}
            </Label>
          )}
          <Select
            onValueChange={onValueChange}
            value={value}
            disabled={isLoading || disabled}
          >
            <FormControl>
              <SelectTrigger className="border-solid focus:ring-primary-500 text-slate-900 font-sans">
                <SelectValue placeholder="Selecione" />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="max-h-96 overflow-auto font-sans z-[9999]">
              {content.map((item) => (
                <SelectItem key={item.value} value={item.value.toString()}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </div>
      </FormItem>
    );
  }
);

SelectGs.displayName = 'SelectGs';

export { SelectGs };
